export default __webpack_public_path__ + "static/char-s-40-zh-Hant-2f661ffc9e99fa35396f713e0d5664ea.webp";